var _defs, _path, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.028101,
    height: 18,
    viewBox: "0 0 18.028101 18",
    fill: "none",
    id: "svg107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs111"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 9.0281213,0 c 2.3624797,0 4.6124797,0.9 6.4124797,2.5875 1.6875,1.8 2.5875,4.05 2.5875,6.4125 0,2.3625 -0.9,4.6125 -2.5875,6.4125 -1.8,1.6875 -4.05,2.5875 -6.4124797,2.5875 -2.3625001,0 -4.6125001,-0.9 -6.4125001,-2.7 -3.48749495,-3.4875 -3.48749495,-9.225 0,-12.7125 C 4.4156212,0.9 6.6656212,0 9.0281213,0 Z m 0,16.875 c 2.1374797,0 4.0499797,-0.7875 5.6249797,-2.25 1.4625,-1.575 2.25,-3.4875 2.25,-5.625 0,-2.1375 -0.7875,-4.05 -2.25,-5.5125 -1.575,-1.575 -3.4875,-2.3625 -5.6249798,-2.3625 -2.1375,0 -4.04999,0.7875 -5.62499,2.25 -3.03750495,3.15 -3.03750495,8.1 0,11.25 1.575,1.4625 3.48749,2.25 5.6249901,2.25 z",
    fill: "#808285",
    id: "path105"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.135311,13.249096 H 9.5728106 v -5.2875 c 0,-0.3375 -0.225,-0.5625 -0.5625,-0.5625 h -1.125004 c -0.3375,0 -0.5625,0.225 -0.5625,0.5625 0,0.3375 0.225,0.5625 0.5625,0.5625 h 0.675004 v 4.725 h -0.675004 c -0.3375,0 -0.5625,0.225 -0.5625,0.5625 0,0.3375 0.225,0.5625 0.5625,0.5625 h 2.2500044 c 0.3375,0 0.5625,-0.225 0.5625,-0.5625 0,-0.3375 -0.225,-0.5625 -0.5625,-0.5625 z",
    fill: "#808285",
    id: "path9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 10.282086,5.1752552 c 0,0.7875 -0.6750003,1.4625 -1.4625003,1.4625 -0.7875,0 -1.462496,-0.5625 -1.462496,-1.4625 0,-0.9 0.674996,-1.462495 1.462496,-1.462495 0.7875,0 1.4625003,0.674995 1.4625003,1.462495 z m -1.0125003,-0.1125 c 0,-0.225 -0.225,-0.45 -0.45,-0.45 -0.225,0 -0.45,0.225 -0.45,0.45 0,0.225 0.225,0.45 0.45,0.45 0.225,0 0.45,-0.225 0.45,-0.45 z",
    fill: "#808285",
    id: "path97"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBg);
export default __webpack_public_path__ + "static/media/infoBg.a41e4e692a1df440c621c99b13c17e85.svg";
export { ForwardRef as ReactComponent };